<script lang="ts">
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import { faEdit, faTrashAlt, faCheck, faCalculator } from '@fortawesome/free-solid-svg-icons'
    import { PaymentMethodsOnInvoices } from '../../modules/posApi/invoices/invoice'
    export let invoicePayment: PaymentMethodsOnInvoices = undefined
    import { createEventDispatcher, onMount } from 'svelte'
    import { PaymentMethodTypeEnum } from '../../modules/posApi/payment-methods/payment-methods'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Zinput from '../_common/z/zinput.svelte'
    import ZContainer from '../_common/z/z-container.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'

    const firstDueOptions = [
        { value: 0, label: 'Data da venda' },
        { value: 1, label: 'Em 1 dia' },
        ...Array.from({ length: 89 }, (_, i) => ({ value: i + 2, label: `Em ${i + 2} dias` })),
    ]
    const dispatch = createEventDispatcher()

    export let pendingTotal = 0
    // abre um pagamento já existente direto no modo de edição (usado pela folha do mobile, que desenha
    // a linha fechada por conta própria). No desktop fica desligado.
    export let startEditing: boolean = false
    let className: string = ''
    export { className as class }

    let step = 1
    let isNew = false
    let inputInstallments
    let inputValue
    async function editEntity() {
        step = 2
    }

    function getTotal() {
        if (pendingTotal < 0) pendingTotal = 0
        invoicePayment.value = pendingTotal
    }

    async function newEntity() {
        isNew = true
        step = 2
        invoicePayment = new PaymentMethodsOnInvoices()
        invoicePayment.installments = 1
    }

    async function cancelEntity() {
        dispatch('cancel')
        invoicePayment = undefined
        step = 1
    }

    async function confirmEntity() {
        if (!invoicePayment.paymentMethod || !invoicePayment.value || !invoicePayment.installments) {
            window.error('Informe todas as opções antes de confirmar.')
            return
        }
        invoicePayment.paymentMethodId = invoicePayment.paymentMethod.paymentMethodId
        if (invoicePayment.paymentMethod.comissionFeeDebt) {
            let fee = invoicePayment.paymentMethod.feePercentage
            if (invoicePayment.paymentMethod.installmentsFee) {
                let feeItem = invoicePayment.paymentMethod.installmentsFee.find((el) => el.installment === invoicePayment.installments)
                if (feeItem) {
                    fee = feeItem.fee
                } else {
                    fee = invoicePayment.paymentMethod.installmentsFee[invoicePayment.paymentMethod.installmentsFee.length - 1].fee
                }
            }
            invoicePayment.feePercentage = fee
        } else {
            invoicePayment.feePercentage = 0
        }
        console.log('invoicePayment', invoicePayment)
        dispatch('added', invoicePayment)
        if (isNew) invoicePayment = undefined
        step = 1
        isNew = false
    }

    function pmChanged(event) {
        if (event.detail.installments > 1) {
            setTimeout(() => inputInstallments?.focus())
        } else {
            inputValue?.focus()
        }
    }

    let totalInstallments = 1
    $: {
        if (inputInstallments && invoicePayment?.paymentMethod) {
            totalInstallments = invoicePayment.paymentMethod.installments || 1
        }
    }
    $: installmentsOptions = Array.from({ length: totalInstallments }, (_, i) => ({ value: i + 1, label: (i + 1).toString() }))

    onMount(() => {
        if (!invoicePayment) newEntity()
        else if (startEditing) step = 2
    })
</script>

{#if invoicePayment !== undefined}
    <div class={className}>
        {#if step === 1}
            <div class="row line h-mobile">
                <div class="col">{invoicePayment.paymentMethod?.label || '-'}</div>
                <div class="col-md-1 text-end">{invoicePayment.installments}</div>
                <div class="col-md-1 text-end">{window.api.utils.utils.toReal(invoicePayment.value)}</div>
                <div class="col-md-2 text-end">
                    <Zbutton color="secondary" icon={faEdit} label="Editar" on:click={editEntity} />
                </div>
            </div>
            <div class="row line h-full content">
                <div class="col">
                    <div class="label">Meio de pgto</div>
                    <div class="item">{invoicePayment.paymentMethod?.label || '-'}</div>
                </div>
                <div class="col-3">
                    <div class="label">Parcelas</div>
                    <div class="item">{invoicePayment.installments}</div>
                </div>
                <div class="col-3">
                    <div class="label">Valor</div>
                    <div class="item">{invoicePayment.value}</div>
                </div>

                <div class="col-md text-center">
                    <Zbutton class="mt-3 mb-2" color="secondary" icon={faEdit} label="Editar" on:click={editEntity} />
                </div>
            </div>
        {/if}
        {#if step === 2}
            <ZContainer>
                <ZContainerCol size={3} sizeM={12}
                    ><ZentitySelect fonte="meioPagamento" label="Meio" bind:value={invoicePayment.paymentMethod} /></ZContainerCol
                >
                <ZContainerCol size={3} sizeM={12}>
                    <Zinput
                        type="select"
                        label="Parcelas"
                        bind:this={inputInstallments}
                        options={installmentsOptions}
                        bind:value={invoicePayment.installments}
                    /></ZContainerCol
                >
                <ZContainerCol size={2} sizeM={12}>
                    <Zinput
                        type="number"
                        label="Valor Total"
                        bind:this={inputValue}
                        bind:value={invoicePayment.value}
                        acts={[{ callback: getTotal, icon: faCalculator, label: null, color: 'secondary' }]}
                    />
                </ZContainerCol>
                <ZContainerCol size={2} sizeM={12}>
                    {#if invoicePayment?.paymentMethod?.type === PaymentMethodTypeEnum.check || invoicePayment?.paymentMethod?.type === PaymentMethodTypeEnum.bankslip}
                        <Zinput type="select" label="Primeiro vencimento" options={firstDueOptions} bind:value={invoicePayment.firstDueInDays} />
                    {/if}
                </ZContainerCol>
                <ZContainerCol flex={true} size={2} sizeM={12}>
                    <Zbutton grow={true} class="me-2" color="red" icon={faTrashAlt} on:click={cancelEntity} />
                    <Zbutton grow={true} color="primary" icon={faCheck} on:click={confirmEntity} /></ZContainerCol
                >
            </ZContainer>
        {/if}
    </div>
{/if}

<style>
    .content .label {
        color: #328866;
        font-weight: 300;
    }
    .content .item {
        margin-top: -3px;
        margin-bottom: 3px;
    }
    @media (max-width: 900px) {
        .btns {
            margin-top: 12px;
        }
    }
</style>
